module.exports = "<div class=\"registerBox\">\r\n    <div class=\"registerTitleBox\">\r\n        <div class=\"registerTitle\">{{_i18n(\"注册\")}}\r\n            <a class=\"BackToLogin\" data-bind=\"attr:{href:urlAddPrefix('/#/login')}\">{{_i18n(\"返回登录\")}}</a>\r\n        </div>\r\n    </div>\r\n    <div class=\"registerTitleformBox\">\r\n        <q-form params=\"app:app\"></q-form>\r\n    </div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/component/reg/Reg.html
// module id = 198
// module chunks = 0